import { useGetCurrencyCodesQuery } from '@graphql/generated';
import type { CurrencyCodeType } from '@shared/utils/currency/currency.types';
import { useMemo } from 'react';

type RegistryCurrencyCodes = Readonly<{
  popularCurrencyCodes: ReadonlyArray<CurrencyCodeType>;
  allCurrencyCodes: ReadonlyArray<CurrencyCodeType>;
}>;

/**
 * Fetches registry currency codes and maps them into the shape expected by CurrencySelectorV2.
 * Apollo caches the underlying query, so multiple callers share a single network request.
 */
export const useRegistryCurrencyCodes = (): RegistryCurrencyCodes | undefined => {
  const { data } = useGetCurrencyCodesQuery();
  return useMemo(() => {
    const staticData = data?.getRegistryStaticData?.currencies;
    if (!staticData) return undefined;
    return {
      popularCurrencyCodes: staticData.topRanked.map(c => c.code as CurrencyCodeType),
      allCurrencyCodes: staticData.ordered.map(c => c.code as CurrencyCodeType),
    };
  }, [data]);
};
